import type { Transition, Variants } from "framer-motion";

export const spring = {
  snappy: { type: "spring", stiffness: 500, damping: 30, mass: 0.8 } as Transition,
  bouncy: { type: "spring", stiffness: 400, damping: 18, mass: 1 } as Transition,
  smooth: { type: "spring", stiffness: 260, damping: 26, mass: 1 } as Transition,
  heavy: { type: "spring", stiffness: 200, damping: 30, mass: 1.4 } as Transition,
  stable: { type: "spring", stiffness: 420, damping: 40, mass: 1 } as Transition,
};

export const easeOut = [0.23, 1, 0.32, 1] as const;

export function staggerContainer(step = 0.06, delay = 0.05): Variants {
  return {
    hidden: {},
    show: { transition: { staggerChildren: step, delayChildren: delay } },
  };
}

export function fadeUp(reduce: boolean): Variants {
  return reduce
    ? { hidden: { opacity: 0 }, show: { opacity: 1, transition: { duration: 0.15 } } }
    : { hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0, transition: spring.smooth } };
}

export const shakeKeyframes = { x: [0, -8, 8, -6, 6, 0] };
export const shakeTransition: Transition = { duration: 0.3, ease: "easeOut" };
